import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { Button, Checkbox, ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    orderTypeId: number,
    months1: boolean,
    months3: boolean,
    months6: boolean,
    months12: boolean,
    months18: boolean,
    months24: boolean,
    testTypes: IListItem[],
    handleCheckboxChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void,
    handleOrderType: (e: React.FormEvent<FormControl & HTMLSelectElement>) => void
}

class EnrollmentInfo extends React.Component<IProps> {
    render = () => {
        return (

            <>
                <div className='col-sm-12'>
                    <FormGroup controlId="formControlsSelect">
                        <ControlLabel>Type</ControlLabel>
                        <FormControl 
                        onChange={this.props.handleOrderType} 
                        value={this.props.orderTypeId} 
                        componentClass="select" placeholder="select"
                            >
                            <option value="select">Select Order Type</option>
                            {this.props.testTypes.map((type, index) => 
                                <option value={type.value}>{type.description}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                </div>
                <div className='col-sm-12'>
                    <h5>Months After Surgery Testing</h5>
                    <FormGroup>
                        <Checkbox  name='months1' checked={this.props.months1} onChange={this.props.handleCheckboxChange} inline>1 mo</Checkbox>
                        <Checkbox  name='months3' checked={this.props.months3} onChange={this.props.handleCheckboxChange} inline>3 mo</Checkbox>{' '}
                        <Checkbox  name='months6' checked={this.props.months6} onChange={this.props.handleCheckboxChange} inline>6 mo</Checkbox>{' '}
                        <Checkbox  name='months12' checked={this.props.months12} onChange={this.props.handleCheckboxChange} inline>12 mo</Checkbox>{' '}
                        <Checkbox  name='months18' checked={this.props.months18} onChange={this.props.handleCheckboxChange} inline>18 mo</Checkbox>{' '}
                        <Checkbox  name='months24' checked={this.props.months24} onChange={this.props.handleCheckboxChange} inline>24 mo</Checkbox>{' '}
                    </FormGroup>
                </div>
            </>
        )
    }
}

export default EnrollmentInfo;